import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/withdrawalMessage'
import { getWithdrawalMessage as getWithdrawalMessageService } from 'services'

const {
  WITHDRAWAL_MESSAGE_REQUEST,
  WITHDRAWAL_MESSAGE_SUCCESS,
  WITHDRAWAL_MESSAGE_ERROR
} = ACTION_TYPES

export function *getWithdrawalMessage() {
  try {
    const response = yield call(getWithdrawalMessageService)
    const message = response.data ? response.data.message : null
    yield put({ type: WITHDRAWAL_MESSAGE_SUCCESS, payload: message })
  } catch (err) {
    yield put({ type: WITHDRAWAL_MESSAGE_ERROR, payload: null })
  }
}

export default function *watchWithdrawalMessage() {
  yield takeLatest(WITHDRAWAL_MESSAGE_REQUEST, getWithdrawalMessage)
}
